module.exports = __webpack_public_path__ + "static/media/2022copa.0e1fa7b9.png";